// extracted by mini-css-extract-plugin
export default {"address-form":"LocationForm_address-form__044oe","title":"LocationForm_title__xW8U+","form":"LocationForm_form__MLxX2"};